module.exports = __webpack_public_path__ + "img/memter.ecf0e1a2.png";